export default {
    "name": "SearchCars",
    "kind": "HoudiniQuery",
    "hash": "71dbc711bc7a7366f6b7f20f1fda01f7eeaec52f328213d6aaaeb6721b6ee953",

    "raw": `query SearchCars($input: SearchCarsInput!) {
  searchCars(input: $input) {
    cars {
      fullname
      options {
        motor
        constructionYears
        carId
        energy
      }
    }
  }
}`,

    "rootType": "Query",
    "stripVariables": [],

    "selection": {
        "fields": {
            "searchCars": {
                "type": "SearchCarsResult",
                "keyRaw": "searchCars(input: $input)",

                "selection": {
                    "fields": {
                        "cars": {
                            "type": "CarModelSearchMatch",
                            "keyRaw": "cars",

                            "selection": {
                                "fields": {
                                    "fullname": {
                                        "type": "String",
                                        "keyRaw": "fullname",
                                        "visible": true
                                    },

                                    "options": {
                                        "type": "CarOption",
                                        "keyRaw": "options",

                                        "selection": {
                                            "fields": {
                                                "motor": {
                                                    "type": "String",
                                                    "keyRaw": "motor",
                                                    "visible": true
                                                },

                                                "constructionYears": {
                                                    "type": "String",
                                                    "keyRaw": "constructionYears",
                                                    "visible": true
                                                },

                                                "carId": {
                                                    "type": "String",
                                                    "keyRaw": "carId",
                                                    "visible": true
                                                },

                                                "energy": {
                                                    "type": "CarEnergy",
                                                    "keyRaw": "energy",
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    },

    "input": {
        "fields": {
            "input": "SearchCarsInput"
        },

        "types": {
            "SearchCarsInput": {
                "carName": "String"
            }
        },

        "defaults": {},
        "runtimeScalars": {}
    },

    "policy": "CacheOrNetwork",
    "partial": false
};

"HoudiniHash=8056bc5e6d5307cebaa481df468d719fe725c494dfc18018ed422fdf7522b8be";